import React, { useState } from 'react';
import manukaImg from '../assets/profile/manukaa.jpg';
import bewaliImg from '../assets/profile/bewali.jpg';
import malinkaImg from '../assets/profile/malinka.jpg';
import rashwinImg from '../assets/profile/rashwin.jpg';
import tharushImg from '../assets/profile/tharush.jpg';
import chiranthaImg from '../assets/profile/chirantha.jpg';
import thisathImg from '../assets/profile/thisath.jpg';
import hiruniImg from '../assets/profile/hiruni.jpg';
import damithImg from '../assets/profile/damith.jpg';
import thamashiImg from '../assets/profile/thamashi.jpg';

function Team() {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      name: "Manuka Karaliyadda",
      position: "CEO",
      image: manukaImg,
      bio: "When I founded Stargate Shipping Pvt Ltd in 2024, after more than a year of planning, I set out with the ambition to create a company that could stand tall in an oligopolized industry. With roots in a family shipping business and a lifelong passion for this trade, I envisioned an organization that would combine tradition with a bold new approach. In just six months, our internal statistics recorded an unprecedented 566% growth, positioning us among the fastest growing companies in the sector. Such rapid growth is a reflection of both where we come from and where we are headed. My early exposure to the shipping industry, instilled in me a deep respect for the complexities of global trade. Stargate Shipping was born from that foundation, enriched by a spirit of innovation that seeks to meet modern challenges with smarter and more agile solutions. This milestone is only the first of many. Our team is determined to build on this momentum, to deliver seamless and reliable shipping solutions, and to help clients navigate an ever-changing global market. At Stargate Shipping, the horizon is wide open, and we are only at the beginning of an extraordinary journey."
    },
    {
      name: "Bewali Perera",
      position: "General Manager",
      image: bewaliImg,
      bio: "I am Bewali Perera, currently serving as an Executive Business Development.In this role, I am responsible for managing the marketing team, overseeing client relationships, and ensuring all business documentation is maintained accurately. My tasks also include preparing performance reports and developing structured marketing plans to drive growth and strengthen our market presence. By combining team leadership with strategic planning, I contribute to achieving organizational objectives while ensuring smooth coordination across business development activities."
    },
    {
      name: "Malinka Sinhabahu",
      position: "Marketing Executive",
      image: malinkaImg,
      bio: "I am Malinka Sinhabahu, representing Stargate Shipping. I am responsible for attracting and developing new clientele while driving business growth in the shipping and logistics industry. In addition, I ensure the smooth handling and movement of cargo, along with the efficient coordination of related operations. An esteemed alumnus of Lyceum International School, I am currently reading for the ACCA – Knowledge Level at Alpha Business School, Colombo. This program is equipping me with the knowledge, skills, and professional values necessary to strengthen logistics operations through enhanced processes and data management. With a background in the freight and shipping industry, I bring in-depth industry exposure and a process-oriented approach, enabling the successful implementation of innovative initiatives that deliver value-added services to all stakeholders."
    },
    {
      name: "Rashwin Weerakkody",
      position: "Marketing Executive",
      image: rashwinImg,
      bio: "I am Rashwin Weerakkody, representing Stargate Shipping, where I am responsible for developing client relationships and driving business growth in the shipping and logistics industry, while also ensuring the smooth handling and movement of cargo and related operations. With a Higher Diploma in Software Engineering and an IT certificate course, I bring strong technical expertise that enhances logistics operations by streamlining processes, improving data management, and supporting the use of digital tools for efficiency. In addition, I have completed a degree in Logistics, which provides me with in-depth industry knowledge and a strategic understanding of supply chain management. By combining my technical background with logistics expertise, I bridge the gap between operational needs and technology-driven solutions, ensuring accuracy, efficiency, and innovation in my work."
    },
    {
      name: "Tharush Shaminda",
      position: "Operation Executive",
      image: tharushImg,
      bio: "I am Tharush Shamindha, serving as an Operation Executive at Stargate Shipping, where I handle day-to-day logistics operations, coordinate shipments, and ensure the efficient flow of cargo across all stages. With a Diploma in Computing from ESOFT and currently pursuing a Higher National Diploma in Computing and Software Engineering at ICBT, I bring strong technical and analytical skills to support operational excellence. My background in computing helps streamline processes, enhance data accuracy, and integrate digital solutions that improve overall efficiency in logistics operations. I am passionate about combining technology and operations to drive productivity, accuracy, and innovation within the shipping industry."
    },
    {
      name: "Chirantha J Ellepola",
      position: "Business Development Executive",
      image: chiranthaImg,
      bio: "Experienced business development specialist with a focus on emerging markets and technology integration. Chirantha leverages data analytics to identify growth opportunities and optimize client acquisition strategies."
    },
    {
      name: "Thisath De Silva",
      position: "Business Development Executive",
      image: thisathImg,
      bio: "Thisath De Silva: A Software Engineering student (IIT) and dynamic Social Media Manager at Stargate Shipping. I am responsible for end-to-end management of the brand's digital ecosystem, developing content strategies, and executing targeted campaigns across multiple platforms (Instagram, Facebook, TikTok, YouTube). My technical proficiency in photo/video editing and graphic design allows me to create authentic, engaging assets that effectively communicate our value proposition. This unique blend of technical and creative skills enables me to not only maintain but actively grow our online community and drive meaningful results."
    },
    {
      name: "Hiruni Perera",
      position: "Documentation Executive",
      image: hiruniImg,
      bio: "Hiruni Perera, I am a dedicated Executive in Documentation at Stargate Shipping (Pvt) Ltd., handling shipping documents, designing vessel schedules, and ensuring smooth, accurate, and compliant operations. I studied at Good Shepherd Convent, Colombo 13, completed Computer Science at NIBM, and am currently pursuing a degree in Software Engineering at NIBM, which enhances my technical and analytical skills.I contribute to process improvements, guide colleagues, and maintain strong communication with stakeholders. Committed to continuous learning and teamwork, my goal is to advance my expertise in logistics and shipping management while contributing to the growth and success of Stargate Shipping and the wider maritime industry."
    },
    {
      name: "Damith Iroshan",
      position: "Marketing Executive",
      image: damithImg,
      bio: "I'm Damitha Iroshan, a marketing professional with a dual-track expertise in corporate strategy and entrepreneurial execution. In my role within the company's Marketing division, I develop integrated campaigns that blend creative storytelling with strategic objectives to build lasting brand authority and drive measurable growth. My approach is deeply customer-centric, focused on creating genuine value and fostering trust at every touchpoint. This perspective has been sharpened by my hands-on experience launching and managing my own ventures, which provided invaluable lessons in resilience, agile innovation, and the direct impact of effective marketing on business survival and success. I am passionate about leveraging this unique blend of experiences to design marketing solutions that not only connect with audiences but also create tangible opportunities for expansion and industry leadership."
    },
    {
      name: "Thamashi Wijerathne, ",
      position: "Documentation Executive",
      image: thamashiImg,
      bio: "I serve as a …… in the Documentation Department at Stargate Shipping (Pvt) Ltd, where I handle shipment documentation and support clearing operations with precision and efficiency. Holding a B.Sc. (Honours) Degree in Business Management, I bring both academic knowledge and practical skills into my role. My background in business management helps me approach documentation with an analytical mindset, streamline processes, and maintain compliance while ensuring smooth operational flow. I am passionate about contributing to the success of our clients and the growth of the company through reliable and well-organized shipping solutions."
    },
  ];

  const openMemberModal = (member) => {
    setSelectedMember(member);
  };

  const closeMemberModal = () => {
    setSelectedMember(null);
  };

  return (
    <section id="team" className="section-padding bg-black relative overflow-hidden">
      <div className="container-custom">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="heading-secondary mb-6">
            Meet our <span className="text-red">team</span>
          </h2>
          <p className="text-xl text-gray-light max-w-3xl mx-auto">
            Our diverse team brings together expertise in logistics, technology, and customer experience
            to deliver exceptional service worldwide.
          </p>
        </div>

        <div className="space-y-8">
          {/* Manuka's card - centered as a single card */}
          <div className="flex justify-center">
            <div 
              className="bg-gradient-to-br from-red/20 to-orange/20 rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-lg hover:scale-105 cursor-pointer backdrop-blur-lg border border-red/40 max-w-2xl w-full"
              onClick={() => openMemberModal(teamMembers[0])}
            >
              {/* Team Member Image */}
              <img 
                src={teamMembers[0].image} 
                alt={teamMembers[0].name || "Team member"}
                className="w-full h-64 object-cover"
              />
              
              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-light text-white mb-2" aria-label={`Name: ${teamMembers[0].name}`}>{teamMembers[0].name}</h3>
                <p className="text-red font-bold mb-4">{teamMembers[0].position}</p>
                <p className="text-gray-light text-sm leading-relaxed">
                  When I founded Stargate Shipping Pvt Ltd in 2024, after more than a year of planning, I set out with the ambition to create a company that could stand tall in an oligopolized industry. With roots in a family shipping business and a lifelong passion for this trade, I envisioned an organization that would combine tradition with a bold new approach. In just six months, our internal statistics recorded an unprecedented 566% growth, positioning us among the fastest growing companies in the sector.
                </p>
              </div>
            </div>
          </div>

          {/* Rest of the team in 3x3 grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            {teamMembers.slice(1).map((member, index) => (
              <div 
                key={index} 
                className="bg-white/10 rounded-2xl overflow-hidden text-center transition-all duration-300 hover:shadow-lg hover:scale-105 cursor-pointer backdrop-blur-lg border border-white/20"
                onClick={() => openMemberModal(member)}
              >
                {/* Team Member Image */}
                <img 
                  src={member.image} 
                  alt={member.name || "Team member"}
                  className="w-full h-64 object-cover"
                />
                
                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-light text-white mb-2" aria-label={`Name: ${member.name}`}>{member.name}</h3>
                  <p className="text-red font-bold">{member.position}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Team Member Modal */}
        {selectedMember && (
          <div className="fixed inset-0 bg-black/90 backdrop-blur-lg z-50 flex items-center justify-center p-4">
            <div className="relative max-w-4xl w-full bg-white/10 rounded-2xl overflow-hidden backdrop-blur-lg border border-white/20" style={{ maxHeight: '90vh' }}>
              <button 
                onClick={closeMemberModal}
                className="absolute top-4 right-4 text-white hover:text-red transition-colors z-10"
              >
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            
              <div className="flex flex-col md:flex-row" style={{ minHeight: '70vh' }}>
                {/* Image Section */}
                <div className="md:w-2/5">
                  <img 
                    src={selectedMember.image} 
                    alt={selectedMember.name}
                    className="w-full h-64 md:h-full object-cover"
                  />
                </div>
              
                {/* Bio Section */}
                <div className="md:w-3/5 p-8 flex flex-col">
                  <h3 className="text-3xl font-bold text-white mb-2">{selectedMember.name}</h3>
                  <p className="text-red text-xl font-medium mb-6">{selectedMember.position}</p>
                
                  <div className="bg-gray-800 rounded-xl p-6 mb-6 flex-grow overflow-y-auto" style={{ maxHeight: '300px' }}>
                    <h4 className="text-white text-lg font-semibold mb-3">Biography</h4>
                    <p className="text-gray-light leading-relaxed">
                      {selectedMember.bio}
                    </p>
                  </div>
                
                  <div className="flex space-x-4 mt-auto">
                    <button 
                      onClick={closeMemberModal}
                      className="bg-gradient-to-r from-red to-orange text-white px-6 py-3 rounded-lg font-semibold hover:from-orange hover:to-red transition-all duration-300"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default Team;